export const THEMES = Object.freeze({
    DARK: 'Dark',
    LIGHT: 'Light',
    SYSTEM: 'System',
});

export const ALLOWED_THEMES = Object.freeze([
    THEMES.DARK,
    THEMES.LIGHT,
    THEMES.SYSTEM,
]);

export const DEFAULT_THEME = THEMES.SYSTEM;
export const DEFAULT_RESOLVED_THEME = THEMES.LIGHT;
export const THEME_STORAGE_KEY = 'portal_theme';

export function normalizeTheme(theme) {
    if (!theme || !ALLOWED_THEMES.includes(theme)) {
        return DEFAULT_THEME;
    }

    return theme;
}

export function normalizeResolvedTheme(theme) {
    return theme === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;
}